import * as z from "zod";
import { AreaFieldSchema } from "@/pages/requests/components";

export type AreaFieldSchemaType = z.infer<typeof AreaFieldSchema>;

export enum AreasField {
  Location = "Location",
  Areas = "Areas",
}

export enum AreasFieldLabel {
  Location = "Location",
}
